import { lens, withLenses } from '@dhmk/zustand-lens';
import { create } from 'zustand';
import { RegionSlice, createRegionSlice } from './regions/region.store';
import { SeasonSlice, createSeasonSlice } from './season/season.store';

export type BoundStore = {
  regions: RegionSlice;
  seasons: SeasonSlice;
};

export const useBoundStore = create<BoundStore>(
  withLenses(() => ({
    regions: lens(createRegionSlice),
    seasons: lens(createSeasonSlice),
  }))
);
